import { Box, Button, SxProps, Theme } from '@mui/material';
import { useFormikContext } from 'formik';
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';
import { CheckoutFormValues } from '../../types/appointments';
import { CheckoutPricing } from '../../hooks/checkouts/useCheckoutPricing';
import useGiftCardsEnabled from '../../hooks/checkouts/useGiftCardsEnabled';

const PILL_SX: SxProps<Theme> = {
  gap: 1,
  padding: '11px 20px 11px 16px',
  minWidth: 0,
  borderRadius: '50px',
  border: '1px solid',
  borderColor: theme => theme.palette.common.black,
  background: theme => theme.palette.common.white,
  color: theme => theme.palette.common.black,
  textTransform: 'none',
  transition: 'background 120ms ease, color 120ms ease',
  '&:hover': {
    background: theme => theme.palette.common.black,
    borderColor: theme => theme.palette.common.black,
    color: theme => theme.palette.common.white,
  },
  '& .MuiSvgIcon-root': { fontSize: 'h3.fontSize' },
  typography: 'h5',
  fontWeight: 700,
};

export default function AddLineItemButtons({
  pricing,
}: {
  pricing: CheckoutPricing;
}) {
  const { values } = useFormikContext<CheckoutFormValues>();
  const giftCardsEnabled = useGiftCardsEnabled({
    customer: values.customer,
    appointment: pricing.modals.appointment,
  });

  if (!pricing.canEditItems) return null;

  return (
    <Box display="flex" flexWrap="wrap" gap={1.25}>
      {pricing.hasAppointment && (
        <Button sx={PILL_SX} onClick={() => pricing.openAddItems('services')}>
          <AddCircleOutlineRounded />
          Add service
        </Button>
      )}
      <Button sx={PILL_SX} onClick={() => pricing.openAddItems('items')}>
        <AddCircleOutlineRounded />
        Add item
      </Button>
      {giftCardsEnabled && (
        <Button sx={PILL_SX} onClick={() => pricing.openAddItems('giftCards')}>
          <AddCircleOutlineRounded />
          Add gift card
        </Button>
      )}
      {pricing.isDiscountAvailable && !pricing.hasDiscount && (
        <Button sx={PILL_SX} onClick={pricing.openDiscountForm}>
          <AddCircleOutlineRounded />
          Add discount
        </Button>
      )}
    </Box>
  );
}
